import React from 'react';

import './widgetTitleComponent.css';

const WidgetTitleComponent = ({showAnim = false, title = null}) => {
  return (
    title && (
      <div
        className={`et-v2-widget-title-container ${showAnim ? 'et-v2-widget-title-container-with-anim' : ''}`}>
        {title}
      </div>
    )
  );
};

export default WidgetTitleComponent;
